import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Joi from 'joi-browser';
import ContractSummary from '../components/ContractSummary';
import PaymentSection from '../components/PaymentSection';
import { transformFieldDefinitionToClasses } from '../utilities/helpers';
import './ContractForm.css';

class ContractForm extends React.Component {
  constructor(props) {
    super(props);
    this.onValidate = this.onValidate.bind(this);
  }
  onValidate(id, value) {
    //  name and value live here as vars/let/CONST (unknown)
    const { validationSchema, onValidatedField } = this.props;
    let errorMessage = '';
    if (value !== '') {
      // does not validate empty fields
      const inputSchema = Joi.reach(validationSchema, id);
      const { error } = Joi.validate(value, inputSchema, {
        abortEarly: false,
      });
      if (!_.isEmpty(error)) {
        // so field is not empty, and there is some error, then assign it to errorMessage.
        const { details: [{ message }] } = error;
        errorMessage = message;
      }
    }
    onValidatedField(id, errorMessage);
  }

  render() {
    const {
      fieldDefinitions,
      userInput,
      validationErrors,
      onChange,
      onSubmit,
      contractSummaryClasses,
    } = this.props;

    const formFields = fieldDefinitions
      ? _.map(fieldDefinitions, (fieldDefinition, fieldName) => {
        const {
          ComponentName,
          label,
          dependency,
          description,
          required,
          options,
          fieldSuffix,
          placeholder,
        } = fieldDefinition;

        const classes = transformFieldDefinitionToClasses(fieldName, fieldDefinition);

        let component = null;

        if (!dependency || (dependency && userInput[dependency])) {
          component = (
            <ComponentName
              key={fieldName}
              id={fieldName}
              name={fieldName}
              value={userInput[fieldName]}
              label={label}
              required={required}
              placeholder={placeholder}
              description={description}
              fieldSuffix={fieldSuffix}
              errorText={validationErrors[fieldName]}
              className={classes}
              onChange={onChange}
              onValidate={this.onValidate}
              {...options}
            />
          );
        } else if (dependency && !userInput[dependency]) {
          // thoughts?
        }

        return component;
      })
      : null;

    return (
      <div className="form">
        <div className="white-box item-box">
          <div className="inner">
            <div className="row form-row">
              <fieldset>{formFields}</fieldset>
            </div>
          </div>
        </div>

        <ContractSummary contract={userInput} contractSummaryClasses={contractSummaryClasses} />

        <PaymentSection />

        <div className="submit-holder">
          <button type="submit" className="btn-large" onClick={onSubmit}>
            Create Contract
          </button>
        </div>
      </div>
    );
  }
}

// disabled because shape of object will differ in the future as it is dynamically generated.
// forbid-prop-types require-default-props
/* eslint-disable react/forbid-prop-types, react/require-default-props */
ContractForm.propTypes = {
  userInput: PropTypes.object,
  validationSchema: PropTypes.object,
  fieldDefinitions: PropTypes.object,
  validationErrors: PropTypes.object,
  contractSummaryClasses: PropTypes.object,
  /* eslint-enable react/forbid-prop-types, react/require-default-props */
  onValidatedField: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ContractForm;



// WEBPACK FOOTER //
// ./src/components/ContractForm.js